import { FunctionComponent } from "react";

const AccessDenied: FunctionComponent = () => {
  return (
    <div style={{ padding: "24px", fontFamily: "Glegoo" }}>
      <h2 style={{ marginBottom: "8px" }}>No Pages Assigned</h2>
      <p style={{ margin: 0 }}>
        Your account does not have page access assigned yet. Please contact your admin.
      </p>
    </div>
  );
};

export default AccessDenied;
